// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"styles_loadingSpinner__C34ci","loading":"styles_loading__7RJxm","spin":"styles_spin__g1iwZ"};